// WebAudio synthetic siren (no external audio files)
let ctx = null;
let osc = null;
let gain = null;
let lfoTimer = null;

export function startSiren() {
  if (osc) return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    osc = ctx.createOscillator();
    gain = ctx.createGain();
    osc.type = "sawtooth";
    osc.frequency.value = 660;
    gain.gain.value = 0.0001;
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    // ramp up
    gain.gain.exponentialRampToValueAtTime(0.15, ctx.currentTime + 0.1);
    // alternate two-tone siren
    let high = true;
    lfoTimer = setInterval(() => {
      if (!osc || !ctx) return;
      high = !high;
      osc.frequency.setTargetAtTime(high ? 880 : 560, ctx.currentTime, 0.05);
    }, 550);
  } catch (e) {
    console.debug("siren: audio non disponibile", e);
  }
}

export function stopSiren() {
  if (lfoTimer) {
    clearInterval(lfoTimer);
    lfoTimer = null;
  }
  try {
    if (gain && ctx) gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.1);
    if (osc) {
      const o = osc;
      setTimeout(() => {
        try { o.stop(); o.disconnect(); } catch (e) { console.debug("siren stop", e); }
      }, 150);
    }
  } catch (e) { console.debug("siren stop", e); }
  osc = null;
  gain = null;
}
